module.exports = __webpack_public_path__ + "static/media/green-macbook.718cf68a.png";